import Search from "@mui/icons-material/Search";
import { InputAdornment, TextField } from "@mui/material";

interface SearchElementsFieldProps {
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
}

export const SearchElementsField = ({
	value,
	onChange,
	placeholder = "Search elements..."
}: SearchElementsFieldProps) => {
	return (
		<TextField
			fullWidth
			size="small"
			placeholder={placeholder}
			value={value}
			onChange={(e) => onChange(e.target.value)}
			slotProps={{
				input: {
					startAdornment: (
						<InputAdornment position="start">
							<Search fontSize="small" sx={{ color: "text.secondary" }} />
						</InputAdornment>
					),
				}
			}}
			sx={{
				"& .MuiOutlinedInput-root": {
					backgroundColor: "#fafbfc",
					borderRadius: 2
				},
			}}
		/>
	);
};